import Props from "components/_properties/index";
import {forwardRef} from "react";


export default forwardRef( Styled );

//-----------------------------------------------------------------
function Styled( props, ref ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { children, styles, ...rest } = props;

  const _style_defaults = {...Props.fill, ...Props.no_overflow, background:''}
  const _style = styles?.reduce( (result, style ) => { return { ...result, ...style } }, _style_defaults ) || _style_defaults;

  //#endregion

  //#region [STYLES]

  const CONTAINER = {
    ref   : ref,
    style : _style,
    ...rest
  }

  //#endregion

  return (
    <div { ...CONTAINER }>
      {children}
    </div>
  )
}